<main class="relative grid min-h-screen place-items-center overflow-hidden bg-slate-50 px-5 py-12">
  <div
    class="pointer-events-none absolute -top-32 -left-28 size-80 rounded-full bg-sky-200/40 blur-3xl"
  ></div>
  <div
    class="pointer-events-none absolute -right-24 -bottom-32 size-96 rounded-full bg-blue-200/40 blur-3xl"
  ></div>

  <section
    class="relative w-full max-w-xl overflow-hidden rounded-3xl border border-slate-200 bg-white px-6 py-10 text-center shadow-xl shadow-slate-200/60 sm:px-12 sm:py-14"
    role="status"
    aria-live="polite"
  >
    <div
      class="mx-auto grid size-20 place-items-center rounded-2xl bg-sky-50 text-sky-600 ring-1 ring-sky-100"
    >
      <lucide-icon name="Clock3" [size]="38" aria-hidden="true" />
    </div>

    <p class="mt-7 mb-2 text-xs font-bold tracking-[0.2em] text-sky-600 uppercase">
      All To Trips
    </p>
    <h1 class="m-0 text-2xl font-bold text-slate-800 sm:text-3xl">
      ระบบกำลังปิดปรับปรุงชั่วคราว
    </h1>
    <p class="mx-auto mt-4 mb-0 max-w-md text-sm leading-7 text-slate-500 sm:text-base">
      ทีมงานกำลังปรับปรุงระบบเพื่อให้สามารถใช้งานได้อย่างมีประสิทธิภาพมากขึ้น
      กรุณากลับมาใช้งานอีกครั้งในภายหลัง
    </p>

    
    <p class="mt-4 mb-0 text-xs text-slate-400">ขออภัยในความไม่สะดวก</p>
  </section>
</main>
